/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Confirm_DeleteInputs */

const en_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this job?`)
};

const de_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Stelle löschen?`)
};

const fr_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cet emploi ?`)
};

const es_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Eliminar este empleo?`)
};

const it_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminare questo lavoro?`)
};

const nl_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze baan verwijderen?`)
};

const pl_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usunąć tę ofertę pracy?`)
};

const fi_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poistetaanko tämä työpaikka?`)
};

const da_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet dette job?`)
};

const sv_jobs_confirm_delete = /** @type {(inputs: Jobs_Confirm_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radera detta jobb?`)
};

/**
* | output |
* | --- |
* | "Delete this job?" |
*
* @param {Jobs_Confirm_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_confirm_delete = /** @type {((inputs?: Jobs_Confirm_DeleteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Confirm_DeleteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_confirm_delete(inputs)
	if (locale === "fr") return fr_jobs_confirm_delete(inputs)
	if (locale === "es") return es_jobs_confirm_delete(inputs)
	if (locale === "it") return it_jobs_confirm_delete(inputs)
	if (locale === "nl") return nl_jobs_confirm_delete(inputs)
	if (locale === "pl") return pl_jobs_confirm_delete(inputs)
	if (locale === "fi") return fi_jobs_confirm_delete(inputs)
	if (locale === "da") return da_jobs_confirm_delete(inputs)
	if (locale === "sv") return sv_jobs_confirm_delete(inputs)
	return en_jobs_confirm_delete(inputs)
});